var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-btn',{attrs:{"color":"primary","to":"/"}},[_vm._v("LOGIN")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }